// 哑铃图
import ChartTemplate from '../ChartTemplate';
export default {
  extends: ChartTemplate,
  methods: {
    async initOptionAfter () {
      await require('highcharts/modules/dumbbell')(this.Highcharts);
    },
  }
}